import AppRoutes from "./routes/AppRoutes";
import "./styles/global.css";
import "./styles/index.css";
import "aos/dist/aos.css"; // Import AOS styles
import AOS from "aos"; // Import AOS library
import { useEffect } from "react";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // Animation duration
      offset: 200, // Offset from the viewport (in pixels)
      once: false, // Animation will trigger every time the element comes into view
      mirror: true, // Animation will repeat when scrolling back
    });
  }, []);
  return <AppRoutes />;
}

export default App;
